import { render, staticRenderFns } from "./ExpandableItemTesoreria.vue?vue&type=template&id=4bace4f1&scoped=true"
import script from "./ExpandableItemTesoreria.vue?vue&type=script&lang=js"
export * from "./ExpandableItemTesoreria.vue?vue&type=script&lang=js"
import style0 from "./ExpandableItemTesoreria.vue?vue&type=style&index=0&id=4bace4f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bace4f1",
  null
  
)

export default component.exports